"use client";

import dayjs from "dayjs";
import { FC } from "react";
import { ArticleListResourceArticles } from "@/api/generated-api";
import Link from "next/link";
import Image from "next/image";
import S from "./index.module.scss";

interface IActualCard {
  actual: ArticleListResourceArticles;
}

const ActualCard: FC<IActualCard> = ({ actual: { title, preview_image, date_publication, id } }) => {
  return (
    <Link className={S.newsItem} href={`/actual/${id}`}>
      <div className={S.imageWrapper}>
        <Image className={S.newsImage} alt={title ?? "News"} src={preview_image ?? ""} width={427} height={240} />
      </div>
      <div className={S.newsInfo}>
        <h4 className={S.newsTitle}>{title}</h4>
        <p className={S.newsDate}>{dayjs(date_publication).format("DD.MM.YYYY")}</p>
      </div>
    </Link>
  );
};

export default ActualCard;
